import React from "react";
import { Pager } from "~/molecules/Pager";

const buildInsightPath = (basePath: string, page: number) =>
  page === 1 ? basePath : `${basePath.replace(/\/$/, "")}/page/${page}`;

export const InsightPager: React.FC<{
  currentPage: number;
  totalPages: number;
  basePath: string;
}> = ({ currentPage, totalPages, basePath }) => {
  return (
    <Pager
      currentPage={currentPage}
      totalPages={totalPages}
      basePath={basePath}
      buildPath={buildInsightPath}
      marginTop={50}
    />
  );
};
